import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { FC } from 'react';
import { Popup } from '../../../../../../../../../shared/components/popup/popup.abstract';
import { IPostalWeightPopup } from '../../postalWeight/postalWeight.popup';
import { dictionaryState } from '../../../../../../../../../shared/components/dictionary/states/dictionary.state';
import { useTranslation } from 'react-i18next';
import { SStack } from '../../../../../../../../order/common/orderGridItems/cells/product/product.cell';
import { IconButton } from '@mui/material';
import SettingsIco from '@mui/icons-material/Settings';
import { SValue } from '../../../../invoice/dictionaries/quantityDiscountsDict/cells/descriptionDict.cell.tsx';

export const NameDictCell: FC<TNameDictCell> = (props) => {
  const { value, row, id, popupStream } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    dictionaryState.pub.selectRow(row);
    popupStream.emit('open', {
      values: {
        id: String(id),
        title: row.name,
      },
    });
  };

  return (
    <SStack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
      <SValue>{value}</SValue>
      <IconButton
        className='button'
        disabled={row.invalid || String(id).includes('new')}
        title={t('settings.post_sectors_one')}
        onClick={handleClick}
        sx={{ p: '3.5px' }}
        size='small'
      >
        <SettingsIco />
      </IconButton>
    </SStack>
  );
};

type TNameDictCell = GridRenderCellParams & {
  popupStream: Popup<IPostalWeightPopup>['stream'];
};
